import { render } from "./Tabs.vue?vue&type=template&id=d8dc1fce&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=d8dc1fce&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d8dc1fce"

export default script